import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BountyStatus, Card, CardBody, CardImg, CardText, CardTitle, TimeProgress } from '@kambria/kambria-lego';
import Utils from 'helpers/utils';
import in_progress_icon from 'static/svg/ic-closed.svg';
import { I18n } from '../../../helpers/i18n';
import { formatSessionDay, formatSessionClockRange } from '../../pages/app/mvp/helper';
import CompactRatingDisplay from './CompactRatingDisplay';
import TotalRatingsComponent from './TotalRatingsComponent';
import starInactiveWithBorder from '../../../static/images/mvp/star_in_active_with_border.png';
import lockIcon from 'static/images/mvp/lock.png';
import './SessionRatingModal.css';

class CardSession extends React.Component {
  state = {
    teams: null,
    prize: null,
  };

  async componentDidMount() {}

  render() {
    const { className, status, data: bounty, descLen, user, linkToSessionDetail } = this.props;
    const userType = user ? user.type : null;
    const classname = className
      ? 'card-session shadow ' + className
      : status === 'UPCOMING'
        ? 'card-session shadow upcoming'
        : 'card-session shadow';
    let stateText = '';
    let styleState = '';
    if (bounty.state == 'is_processing') {
      stateText = I18n.t('ongoing');
      styleState = 'in_progress';
    } else if (bounty.state == 'is_not_started') {
      stateText = I18n.t('upcoming');
      styleState = 'upcoming';
    } else if (bounty.state == 'is_ended') {
      stateText = I18n.t('completed');
      styleState = 'ended';
    }
    if (bounty.state == 'reject') {
      stateText = I18n.t('rejected');
      styleState = 'in_progress';
    }
    if (bounty.state == 'waiting_confirm') {
      stateText = I18n.t('waiting_confirm_session');
      styleState = 'in_progress';
    }
    if (bounty.state == 'confirm') {
      stateText = I18n.t('session_confirmed');
      styleState = 'confirmed';
    }

    const days = [
      I18n.t('sunday'),
      I18n.t('monday'),
      I18n.t('tuesday'),
      I18n.t('wednesday'),
      I18n.t('thursday'),
      I18n.t('friday'),
      I18n.t('saturday'),
    ];

    let startTimeText = formatSessionDay(bounty.startTime, days);
    let timeText = formatSessionClockRange(bounty.startTime, bounty.endTime);
    let isRegistered = userType == 'seniorBuddy' ? bounty?.isRegistered : false;
    const completeInfo = bounty.isCompleted ?? '';
    const completeMap = {
      done: ` | ${I18n.t('session_completed')}`,
      failed: ` | ${I18n.t('session_failed')}`,
      not_done: ` | ${I18n.t('session_not_completed')}`,
    };

    const completeString = completeMap[completeInfo] ?? '';
    const isMySessionPage = window.location.pathname.includes('my-session');
    const link = linkToSessionDetail || isMySessionPage ? 'session-detail' : 'session';
    const isSessionCard = linkToSessionDetail || isMySessionPage;
    const showTimeOffOverlay = !isSessionCard && bounty.guideStatus === 'inactive';

    // Check if user is explorer or not logged in - hide end date in these cases
    const isExplorer =
      !user ||
      user.mvpUserType === 'explorer' ||
      user.type === 'explorer' ||
      (user.type === 'senior' && !user.mvpUserType); // backward compatibility
    const shouldShowEndDate = !isExplorer && bounty.endTime;
    // Không show rating nếu trạng thái đang là Đang diễn ra, Sắp diễn ra, Đã xác nhận, Chờ xác nhân
    const isShowRatingInfo =
      status !== 'is_processing' && status !== 'is_not_started' && status !== 'confirm' && status !== 'waiting_confirm';

    return (
      <Card className={classname}>
        <Link className="topic-card-image-link" to={`/${link}/${bounty._id}`}>
          <CardImg imgSrc={bounty.images}>
            {bounty.categoryName ? <span className="value">{bounty.categoryName} </span> : null}
            {showTimeOffOverlay ? (
              <div
                className="topic-time-off-overlay"
                data-testid="topic-time-off-overlay"
                aria-hidden="true"
              >
                <img src={lockIcon} alt="" className="topic-time-off-overlay-icon" />
                <span>{I18n.t('topic_guide_status_paused')}</span>
              </div>
            ) : null}
          </CardImg>
        </Link>
        <CardBody>
          {isRegistered && (
            <p className={`is_registered ${completeInfo}`}>
              {I18n.t('already_registered')}
              {completeString}
            </p>
          )}
          <div className="title-state-session">
            <Link to={`/${link}/${bounty._id}`}>
              <CardTitle>{bounty.title}</CardTitle>
            </Link>
            {isSessionCard ? (
              <div className="session-card-status-row">
                <CardText className={`${styleState} no-margin-bottom`}>{stateText}</CardText>
                {bounty.needToRate && isShowRatingInfo && (
                  <Link
                    className="session-card-rating-cta"
                    to={`/session-detail/${bounty.sessionUserId || bounty._id}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {I18n.t('session_card_inline_promote_ratting_title')}
                    <img src={starInactiveWithBorder} alt="" className="session-card-rating-cta-star-img" />
                  </Link>
                )}
                {!bounty.needToRate && isShowRatingInfo && (
                  <Link
                    to={`/session-detail/${bounty.sessionUserId || bounty._id}`}
                    onClick={(e) => e.stopPropagation()}
                    style={{ display: 'inline-flex' }}
                  >
                    <CompactRatingDisplay
                      score={bounty.dataRatingTopic?.totalPointEvaluating ?? 0}
                      hasRating={bounty.dataRatingTopic != null && bounty.dataRatingTopic.totalEvaluating > 0}
                      isOnCardSession={true}
                    />
                  </Link>
                )}
              </div>
            ) : (
              bounty.dataRatingTopic != null &&
              isShowRatingInfo && (
                <div className="topic-card-rating-row" style={{ marginTop: '4px' }}>
                  <Link
                    to={`/${link}/${bounty._id}`}
                    onClick={(e) => e.stopPropagation()}
                    style={{ display: 'inline-flex' }}
                  >
                    <TotalRatingsComponent
                      totalPointEvaluating={bounty.dataRatingTopic.totalPointEvaluating}
                      totalEvaluating={bounty.dataRatingTopic.totalEvaluating}
                      isSmallStar
                      isOnCardTopic={true}
                    />
                  </Link>
                </div>
              )
            )}
          </div>
          {/* Short Description */}
          {bounty.description && (
            <CardText
              className="topic-description"
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                color: '#6B7280',
                fontSize: '14px',
                lineHeight: '1.5',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {bounty.description}
            </CardText>
          )}
          {/* End Date */}
          {shouldShowEndDate && (
            <CardText
              className="topic-end-date"
              style={{
                marginTop: '4px',
                marginBottom: '8px',
                color: '#9CA3AF',
                fontSize: '12px',
              }}
            ></CardText>
          )}
          <div className="session-time">
            <div className="session-time-content">
              {isMySessionPage ? (
                <div className="d-flex justify-content-between">
                  <span className="day">{startTimeText}</span>
                  <span className="time">{timeText}</span>
                </div>
              ) : (
                <Link className="view-topic" to={`/${link}/${bounty._id}`}>
                  {I18n.t('topic_card_button_action')}
                </Link>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default connect(null, {})(CardSession);
